/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
import { MapTo, Container } from '@adobe/aem-react-editable-components';
import '../../libs/aemComponents/Container';
import '../../libs/aemComponents/ExperienceFragment';
import {
  EditableHTLWrapper,
  StaticWrapper,
  CardHorizontalMini,
  MiniCardCarouselContainer,
  CardCarouselContainer,
  CardHorizontalFeature,
  BannerFeature,
  CardLayered,
  CardVertical,
  RichText,
  BannerLayered,
  LinkList,
  AccordionContainer,
  BrandRibbon,
  IconBlock,
  CobrandCardHorizontalFlexible,
  LinkBanner,
  GeneralMessage,
  Hero,
  VariableColumnContainer,
  Mosaic,
  BannerText,
  DataBlock,
  AccordionContainerEnhanced,
  NavigationContainerWrapper,
  NavigationUtilityLinkWrapper,
  NavigationWrapper,
  CarouselGallery,
  CardSummary,
  Media,
  TabContainer,
  Footer,
  Text,
} from '@marriott/mi-common-static-components';
import { DynamicHotelListingEditable, CardCarouselResorts } from '@marriott/mi-brands-components';
import {
  SearchFormEditable,
  MeetingsAndEventsSearchFormEditable,
  TabbedSearchForm,
} from '@marriott/mi-shop-components';
import {
  SearchFormEditable as LuxurySearchFormEditable,
  SearchResultsComponentEditable,
  StaticDestinationTableAuthoring,
} from '@marriott/mi-luxury-components';
import { MerchandisingSmallBanner, MerchandisingHeroBanner } from '@marriott/mi-merch-components';
import { Heading, Button, Image } from '@marriott/mi-ui-library';
import {
  HeroBanner,
  IconFeatureBanner,
  StickyComponentWrapper,
  Postcard,
  PostcardContainer,
} from '@marriott/mi-homepage-components';
import { MMNComponentEditable } from '@marriott/mi-ppv5-components';

export const AEM_REACT_MAPPING = {
  [`mi-aem-common-spa/components/experiencefragment`]: Container,
  [`mi-aem-common-spa/components/common/staticwrapper`]: StaticWrapper,
  [`mi-aem-common-spa/components/content/cardhorizontalmini`]: CardHorizontalMini,
  [`mi-aem-common-spa/components/content/cardcarouselcontainer`]: CardCarouselContainer,
  [`mi-aem-common-spa/components/content/cardhorizontalfeature`]: CardHorizontalFeature,
  [`mi-aem-common-spa/components/content/card-mini-carousel-container`]: MiniCardCarouselContainer,
  [`mi-aem-common-spa/components/content/cardlayered`]: CardLayered,
  [`mi-aem-common-spa/components/content/cardvertical`]: CardVertical,
  [`mi-aem-common-spa/components/content/richtext`]: RichText,
  [`mi-aem-common-spa/components/content/bannerlayered`]: BannerLayered,
  [`mi-aem-common-spa/components/content/linklist`]: LinkList,
  [`mi-aem-common-spa/components/content/accordioncontainer`]: AccordionContainer,
  [`mi-aem-common-spa/components/content/brandribbon`]: BrandRibbon,
  [`mi-aem-common-spa/components/content/iconblock`]: IconBlock,
  [`mi-aem-common-spa/components/content/cobrandcardhorizontalflexible`]: CobrandCardHorizontalFlexible,
  [`mi-aem-common-spa/components/content/linkbanner`]: LinkBanner,
  [`mi-aem-common-spa/components/content/generalmessage`]: GeneralMessage,
  [`mi-aem-common-spa/components/content/hero`]: Hero,
  [`mi-aem-common-spa/components/content/variablecolumncontainer`]: VariableColumnContainer,
  [`mi-aem-common-spa/components/content/merchandisingsmallbanner`]: MerchandisingSmallBanner,
  [`mi-aem-common-spa/components/content/merchandisingherobanner`]: MerchandisingHeroBanner,
  [`mi-aem-common-spa/components/content/mosaic`]: Mosaic,
  [`mi-aem-common-spa/components/content/bannertext`]: BannerText,
  [`mi-aem-common-spa/components/content/text`]: Text,
  [`mi-aem-common-spa/components/title`]: Heading,
  [`mi-aem-common-spa/components/button`]: Button,
  [`mi-aem-common-spa/components/image`]: Image,
  [`mi-aem-common-spa/components/content/accordioncontainerenhanced`]: AccordionContainerEnhanced,
  [`mi-aem-common-spa/components/content/datablock`]: DataBlock,
  [`mi-aem-common-spa/components/content/bannerfeature`]: BannerFeature,
  [`mi-aem-common-spa/components/content/cardsummary`]: CardSummary,
  [`mi-aem-common-spa/components/content/media`]: Media,
  [`mi-aem-common-spa/components/content/tabcontainer`]: TabContainer,
  [`mi-aem-common-spa/components/content/carouselgallery`]: CarouselGallery,
  [`mi-aem-common-spa/components/content/mmn-container`]: MMNComponentEditable,

  //Homepage components mapping
  [`mi-aem-homepage-spa/components/content/global-navigation`]: NavigationContainerWrapper,
  [`mi-aem-homepage-spa/components/content/utilityNavigation`]: NavigationUtilityLinkWrapper,
  [`mi-aem-homepage-spa/components/content/primaryNavigation`]: NavigationWrapper,
  [`mi-aem-homepage-spa/components/content/herobanner`]: HeroBanner,
  ['mi-aem-homepage-spa/components/content/universal-footer']: Footer,
  [`mi-aem-homepage-spa/components/content/iconfeaturebanner`]: IconFeatureBanner,
  [`mi-aem-homepage-spa/components/content/postcard`]: Postcard,
  [`mi-aem-homepage-spa/components/content/postcardcontainer`]: PostcardContainer,

  //Shop components mapping
  [`mi-aem-shop-spa/components/content/homepagesearch/v1/homepagesearch`]: SearchFormEditable,
  [`mi-aem-shop-spa/components/content/meetingssearchform/v1/meetingssearchform`]: MeetingsAndEventsSearchFormEditable,
  [`mi-aem-shop-spa/components/content/tabbedsearchformwrapper/v1/tabbedsearchformwrapper`]: TabbedSearchForm,
  [`mi-aem-shop-spa/components/content/baselinesearchform/v1/baselinesearchform`]: SearchFormEditable,

  //Luxury components mapping
  [`mi-aem-luxury-spa/components/content/baselinesearchform/v1/baselinesearchform`]: LuxurySearchFormEditable,
  [`mi-aem-luxury-spa/components/content/map-clusters/v1/map-clusters`]: SearchResultsComponentEditable,
  [`mi-aem-luxury-spa/components/content/staticdestinations/v1/staticdestinations`]: StaticDestinationTableAuthoring,

  //Brands components mapping
  [`mi-aem-brands-spa/components/content/dynamichotellisting/v1/dynamichotellisting`]: DynamicHotelListingEditable,
  [`mi-aem-brands-spa/components/content/dynamicfeaturedhotels/v1/dynamicfeaturedhotels`]: CardCarouselResorts,
};

export const defineComponentMapping = (
  allowedComponents,
  pagePath,
  isAuthorMode,
  pageProps,
  isRtl,
  brandSlug,
  featureFlagLogo
) => {
  MapTo(`mi-aem-common-spa/components/content/bannertext`)(BannerText);
  MapTo(`mi-aem-common-spa/components/common/staticwrapper`)(StaticWrapper);
  MapTo(`mi-aem-common-spa/components/content/cardhorizontalmini`)(CardHorizontalMini);
  MapTo(`mi-aem-common-spa/components/content/cardhorizontalfeature`)(CardHorizontalFeature);
  MapTo(`mi-aem-common-spa/components/content/cardlayered`)(props => (
    <CardLayered {...props} featureFlagLogo={featureFlagLogo} />
  ));
  MapTo(`mi-aem-common-spa/components/content/cardvertical`)(CardVertical);
  MapTo(`mi-aem-common-spa/components/content/richtext`)(RichText);
  MapTo(`mi-aem-common-spa/components/content/bannerlayered`)(BannerLayered);
  MapTo(`mi-aem-common-spa/components/content/linklist`)(LinkList);
  MapTo(`mi-aem-common-spa/components/content/mosaic`)(props => <Mosaic {...props} rtlEnable={isRtl} />);
  MapTo(`mi-aem-common-spa/components/title`)(Heading);
  MapTo(`mi-aem-common-spa/components/button`)(Button);
  MapTo(`mi-aem-common-spa/components/image`)(Image);
  MapTo(`mi-aem-common-spa/components/content/datablock`)(DataBlock);
  MapTo(`mi-aem-common-spa/components/content/brandribbon`)(props => (
    <BrandRibbon {...props} featureFlagLogo={featureFlagLogo} />
  ));
  MapTo(`mi-aem-common-spa/components/content/iconblock`)(IconBlock);
  MapTo(`mi-aem-common-spa/components/content/cobrandcardhorizontalflexible`)(CobrandCardHorizontalFlexible);
  MapTo(`mi-aem-common-spa/components/content/linkbanner`)(LinkBanner);
  MapTo(`mi-aem-common-spa/components/content/generalmessage`)(GeneralMessage);
  MapTo(`mi-aem-common-spa/components/content/hero`)(Hero);
  MapTo(`mi-aem-common-spa/components/content/carouselgallery`)(CarouselGallery);
  MapTo(`mi-aem-common-spa/components/content/card-mini-carousel-container`)(MiniCardCarouselContainer);
  MapTo(`mi-aem-common-spa/components/content/cardsummary`)(CardSummary);
  MapTo(`mi-aem-common-spa/components/content/bannerfeature`)(props => <BannerFeature {...props} />);
  MapTo(`mi-aem-common-spa/components/content/media`)(props => <Media {...props} />);
  MapTo(`mi-aem-common-spa/components/content/accordioncontainer`)(props => (
    <AccordionContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));
  MapTo(`mi-aem-common-spa/components/content/cardcarouselcontainer`)(props => (
    <CardCarouselContainer
      {...props}
      isAuthorMode={isAuthorMode}
      allowedComponents={allowedComponents}
      rtlEnable={isRtl}
    />
  ));
  MapTo(`mi-aem-common-spa/components/content/merchandisingsmallbanner`)(
    props => <MerchandisingSmallBanner {...props} isAuthorMode={isAuthorMode} />,
    { emptyLabel: 'MerchandesingSmallBanner', isEmpty: false }
  );
  MapTo(`mi-aem-common-spa/components/content/merchandisingherobanner`)(
    props => <MerchandisingHeroBanner {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'MerchandisingHeroBanner',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/accordioncontainerenhanced`)(props => (
    <AccordionContainerEnhanced {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));
  MapTo(`mi-aem-common-spa/components/content/tabcontainer`)(props => (
    <TabContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));

  MapTo(`mi-aem-common-spa/components/content/variablecolumncontainer`)(props => (
    <VariableColumnContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));

  MapTo(`mi-aem-common-spa/components/content/text`)(props => <Text {...props} isAuthorMode={isAuthorMode} />, {
    emptyLabel: 'text',
    isEmpty: false,
  });

  MapTo(`mi-aem-common-spa/components/content/mmn-container`)(
    props => <MMNComponentEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'MMNComponent',
      isEmpty: false,
    }
  );

  //Homepage components
  MapTo(`mi-aem-homepage-spa/components/content/herobanner`)(HeroBanner);
  MapTo(`mi-aem-homepage-spa/components/content/utilityNavigation`)(NavigationUtilityLinkWrapper);
  MapTo(`mi-aem-homepage-spa/components/content/primaryNavigation`)(NavigationWrapper);
  MapTo(`mi-aem-homepage-spa/components/content/iconfeaturebanner`)(IconFeatureBanner);
  MapTo(`mi-aem-homepage-spa/components/content/global-navigation`)(props => (
    <NavigationContainerWrapper {...props} isAuthorMode={isAuthorMode} />
  ));
  MapTo('mi-aem-homepage-spa/components/content/universal-footer')(Footer, {
    emptyLabel: 'Footer',
    isEmpty: false,
  });
  MapTo(`mi-aem-homepage-spa/components/content/postcard`)(props => (
    <Postcard {...props} isAuthorMode={isAuthorMode} />
  ));
  MapTo(`mi-aem-homepage-spa/components/content/postcardcontainer`)(props => (
    <PostcardContainer {...props} isAuthorMode={isAuthorMode} />
  ));
  //Brands components mapping
  MapTo(`mi-aem-brands-spa/components/content/dynamichotellisting/v1/dynamichotellisting`)(
    props => <DynamicHotelListingEditable {...props} isAuthorMode={isAuthorMode} brandSlug={brandSlug} />,
    {
      emptyLabel: 'RegionCardEditable',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-brands-spa/components/content/dynamicfeaturedhotels/v1/dynamicfeaturedhotels`)(props => (
    <div className={`${props?.model?.styleclass ?? ''}`}>
      <CardCarouselResorts
        {...props}
        isAuthorMode={isAuthorMode}
        acceptLanguage={pageProps?.headersData['accept-language']}
        requestId={pageProps?.requestId}
        isDTT={pageProps?.isDTT}
      />
    </div>
  ));

  // if global nav is present, wrap SearchFormEditable and pass necessary props in,
  // otherwise use it normally
  const getSearchFormComponent = props =>
    Object.values(pageProps.model?.cqItems?.root?.[':items']?.responsivegrid?.[':items'] || {}).some(
      c => c.id === 'hp-global-navigation'
    ) ? (
      <StickyComponentWrapper {...props}>
        {(isSticky, refCallback) => (
          <SearchFormEditable
            {...props}
            currentLocale={pageProps.currentLocale}
            isSticky={isSticky}
            isPositionedExternally={true}
            refCallback={refCallback}
          />
        )}
      </StickyComponentWrapper>
    ) : (
      <SearchFormEditable {...props} currentLocale={pageProps.currentLocale} />
    );
  //Shop components

  MapTo(`mi-aem-shop-spa/components/content/homepagesearch/v1/homepagesearch`)(getSearchFormComponent);
  MapTo(`mi-aem-shop-spa/components/content/baselinesearchform/v1/baselinesearchform`)(getSearchFormComponent);
  MapTo(`mi-aem-shop-spa/components/content/meetingssearchform/v1/meetingssearchform`)(
    props => <MeetingsAndEventsSearchFormEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'MeetingsAndEventsSearchForm',
      isEmpty: false,
    }
  );
  //Luxury components
  //!important: remove isSearchFormUsedInBrandsPage when Brands team moves to phoenix-header
  MapTo(`mi-aem-luxury-spa/components/content/baselinesearchform/v1/baselinesearchform`)(
    props => (
      <LuxurySearchFormEditable
        {...props}
        isAuthorMode={isAuthorMode}
        isPositionedExternally={false}
        isSearchFormUsedInBrandsPage={true}
      />
    ),
    {
      emptyLabel: 'SearchForm',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-luxury-spa/components/content/map-clusters/v1/map-clusters`)(
    props => (
      <SearchResultsComponentEditable {...props} isAuthorMode={isAuthorMode} featureFlagLogo={featureFlagLogo} />
    ),
    {
      emptyLabel: 'SearchResultsComponentEditable',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-shop-spa/components/content/tabbedsearchformwrapper/v1/tabbedsearchformwrapper`)(
    props => <TabbedSearchForm {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'TabbedSearchForm',
      isEmpty: false,
    }
  );

  MapTo('mi-aem-luxury-spa/components/content/staticdestinations/v1/staticdestinations')(
    props => <StaticDestinationTableAuthoring {...props} isAuthorMode={isAuthorMode} />,
    { emptyLabel: 'Static Destinations', isEmpty: false }
  );

  const existingMappings = Object.keys(AEM_REACT_MAPPING);
  if (allowedComponents) {
    allowedComponents.forEach(mapping => {
      const baseModelPath = '/jcr:content/root/responsivegrid/';
      const componentPath = mapping.path.split(baseModelPath)[1];

      if (existingMappings.indexOf(componentPath) === -1) {
        MapTo(componentPath)(EditableHTLWrapper, {
          emptyLabel: mapping.title,
          isEmpty: false,
        });
      } else {
        console.log('mapping exists', componentPath);
      }
    });
  }
};
